import { render, staticRenderFns } from "./MyTaskView.vue?vue&type=template&id=e4b0cc52&scoped=true&"
import script from "./MyTaskView.vue?vue&type=script&lang=js&"
export * from "./MyTaskView.vue?vue&type=script&lang=js&"
import style0 from "./MyTaskView.vue?vue&type=style&index=0&id=e4b0cc52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b0cc52",
  null
  
)

export default component.exports